import useKeyBinder, { KeyEnum } from 'app/hooks/useKeyBinder';
import { ArrowDownIcon } from 'assets/icons';
import { Calendar } from 'dayzed';
import { useContext, useState } from 'react';
import { DatePickerContext } from './context';

import MonthPicker from './MonthPicker';
import { monthNamesShort, weekdayNamesShort } from './utils';
import YearPicker from './YearPicker';

export default function PickerHeader({
  calendar,
  onDateChange,
  date,
  maxDate,
  minDate,
}: {
  calendar: Calendar;
  date?: Date;
  maxDate?: Date;
  minDate?: Date;
  onDateChange: (d: Date) => void;
}) {
  const [view, setView] = useState<
    'year-picker' | 'month-picker' | 'day-picker'
  >('day-picker');

  return (
    <div className="text-sm h-20 border-b bg-gray-lighter bg-opacity-10 text-gray-dark">
      {view === 'day-picker' && (
        <div className="py-2 flex flex-col gap-2">
          <div className="flex justify-center items-center gap-2">
            <BackwardButton />

            <span
              className="cursor-pointer font-semibold rounded flex items-center gap-1 border py-1 px-2 w-24 justify-center"
              onClick={() => setView('month-picker')}
            >
              {monthNamesShort[calendar.month]}
            </span>

            <YearPicker
              month={calendar.month + 1}
              value={calendar.year}
              onChange={onDateChange}
              maxDate={maxDate}
              minDate={minDate}
            />

            <ForwardButton />
          </div>
          <WeekDaysList />
        </div>
      )}

      {view === 'month-picker' && (
        <MonthPicker
          year={calendar.year}
          maxDate={maxDate}
          minDate={minDate}
          onChange={(d) => {
            onDateChange(d);
            setView('day-picker');
          }}
        />
      )}
    </div>
  );
}

function BackwardButton() {
  const { getBackProps, calendars } = useContext(DatePickerContext);
  return (
    <button
      className="rounded p-2 flex justify-center"
      {...getBackProps({ calendars })}
    >
      <ArrowDownIcon className="transform rotate-90 w-3 h-3" />
    </button>
  );
}

function ForwardButton() {
  const { getForwardProps, calendars } = useContext(DatePickerContext);
  return (
    <button
      className="rounded p-2 flex justify-center"
      {...getForwardProps({ calendars })}
    >
      <ArrowDownIcon className="transform -rotate-90 w-3 h-3" />
    </button>
  );
}

function WeekDaysList() {
  return (
    <div className="grid grid-cols-7 place-content-start text-gray-700">
      {weekdayNamesShort.map((weekday) => (
        <div className="text-center" key={weekday}>
          {weekday}
        </div>
      ))}
    </div>
  );
}
